export enum VisitScheduleDaysStatusEnum {
  DISPATCHED = "DISPATCHED",
  PARTIAL_DISPATCHED = "PARTIAL_DISPATCHED",
  PUBLISHED = "PUBLISHED",
  PARTIAL_PUBLISHED = "PARTIAL_PUBLISHED",
  NOT_DISPATCHED = "NOT_DISPATCHED",
  NOT_PARTIAL_DISPATCHED = "NOT_PARTIAL_DISPATCHED",
  NOT_PUBLISHED = "NOT_PUBLISHED",
  NOT_PARTIAL_PUBLISHED = "NOT_PARTIAL_PUBLISHED",
}


